module.exports = __webpack_public_path__ + "img/Inflammation-GBM_10X_TPCP.d316a2d7.png";